import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-language-dialog-icon',
    styleUrls: ['./language-dialog-icon.component.scss'],
    templateUrl: './language-dialog-icon.component.html'
})
export class LanguageDialogIconComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

}
